import posthog from "posthog-js"

// Public client-side identifiers — ship in every bundle; deliberately in source, not .env.
// Empty until the pakketransport project exists in PostHog (EU); initPostHog is a no-op meanwhile.
const POSTHOG_KEY = ""
const POSTHOG_HOST = "https://eu.i.posthog.com"

let initialized = false

export function initPostHog(): void {
  if (initialized) return

  if (!POSTHOG_KEY) {
    console.warn("PostHog API key not configured. Analytics disabled.")
    return
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    persistence: "localStorage",
    disable_session_recording: true,
    opt_out_capturing_by_default: import.meta.env.DEV && !import.meta.env.VITE_POSTHOG_DEV,
    loaded: () => {
      initialized = true
    }
  })
}

export function isPostHogEnabled(): boolean {
  return initialized && !!POSTHOG_KEY
}

export function getPostHog() {
  return posthog
}
